import { Node } from '@tiptap/pm/model';
import { URL_REGEX } from '../../../validation/validationConstants';
import { findMatchingTextRanges } from '../../utils/findMatchingTextRanges';

/**
 * Regular expression to match custom protocols like `obsidian://`, etc.
 * If it detects a custom protocol (e.g. a string followed by `://`), it will be more permissive until
 * the first whitespace or end of the string.
 */
const CUSTOM_PROTOCOL_REGEX = /([a-zA-Z][a-zA-Z0-9+.-]*):\/\/([^\s/$.?#:].[^\s]*)/;
export const COMBINED_REGEX = new RegExp(`(${CUSTOM_PROTOCOL_REGEX.source})|(${URL_REGEX.source})`, 'g');

export const findAutolinkTextRanges = (doc: Node): ReturnType<typeof findMatchingTextRanges> => {
    const { schema } = doc.type;
    // Nodes that cannot contain autolinks
    const forbiddenNodes = [schema.nodes.codeBlock];
    // marks that cannot contain autolinks
    const forbiddenMarks = [schema.marks.link, schema.marks.code, schema.marks.textMention];
    return findMatchingTextRanges(doc, COMBINED_REGEX, forbiddenMarks, forbiddenNodes).filter(
        ({ text }) => !text.includes('..') && !text.startsWith('.'),
    );
};
